import * as types from './boards.types';
export const boardsPageSelectors: types.IBoardPageSelectors = {
  selectBoards: (state) => state.page.boards.boardsIds,
  selectCurrentBoard: (state) => state.page.boards.currentBoard,
};
